<template>
	<div>
		<h4 class="filter-title" v-if="title">{{ title }}</h4>
		<div>
			<formGenerator v-if="filter" :schema="filter.schema" :model="filter.model" :options="filter.options"></formGenerator>
		</div>
	</div>
</template>

<script>

    import VueFormGenerator from "vue-form-generator";
    import "vue-form-generator/dist/vfg.css";  // optional core css additions

    export default {
        name: 'filterGenerator',
        components: { "formGenerator": VueFormGenerator.component},
        props: {
            title: {
                type: String,
	            default: null
            },
            filter: {
                type: Object,
                required: true,
                twoWay: true
            }
        },
        data: function () {
            return {

            }
        },
        mounted () {

        }
    }
</script>

<style >
	.vue-form-generator {
		z-index: 3;
		height: 100%;
		// overflow: auto;
	}
	.vue-form-generator .form-group label {
		margin-bottom: 0;
		font-weight: 500;
	}
	.vue-form-generator .field-switch .field-wrap label {
		margin: 0 10px 10px 10px;
	}
	.vue-form-generator .form-group {

	}
	.vue-form-generator .form-group {
		line-height: 35px;
		margin-bottom: 0;
	}
	.vue-form-generator .form-control {
		display: block;
		padding: 6px 12px;
		font-size: 14px;
		line-height: 1.42857143;
		transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	}
	.vue-form-generator .form-control:focus {
	}

	.vue-form-generator .field-submit input {
	}
	.vue-form-generator .field-switch input:checked ~ .label {
		background: #75508e;
	}
	.vue-form-generator .field-submit {
		text-indent: 0;
		padding: 3px;

	}
	.vue-form-generator .field-wrap {
		display: block !important;
	}
	.vue-form-generator fieldset {
		margin-top: 5px;
	}
	.vue-form-generator .form-control {
	}

	.vue-form-generator .field-wrap button, .vue-form-generator .field-wrap input[type=submit] {
		display: block;
		padding: 6px 12px;
		margin: 0;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		touch-action: manipulation;
		cursor: pointer;
		user-select: none;
		color: #333;
		background-color: #fff;
		border: 1px solid #ccc;
		border-radius: 4px;
		float: left;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/form/filter.vue